/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfAppointment } from '../../models/data-page-of-appointment';

export interface AppointmentPrintSearch$Params {
  providerId?: string | null;
  isResource?: string | null;
  emrpracticeId?: string | null;
  apptDate?: string | null;
  pageNumber?: number;
}

export function appointmentPrintSearch(http: HttpClient, rootUrl: string, params?: AppointmentPrintSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfAppointment>> {
  const rb = new RequestBuilder(rootUrl, appointmentPrintSearch.PATH, 'get');
  if (params) {
    rb.query('providerId', params.providerId, {});
    rb.query('isResource', params.isResource, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('apptDate', params.apptDate, {});
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfAppointment>;
    })
  );
}

appointmentPrintSearch.PATH = '/appointment/printlist';
